module.exports = __webpack_public_path__ + "media/lobby_selfintro.1a7dacf0.mp3";